<template>
  <div class="changePassword">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
      <el-form-item class="marBot0">
        <h2>修改密码</h2>
      </el-form-item>
      <el-form-item prop="oldPass">
        <el-input v-model="ruleForm.oldPass" placeholder="输入旧密码："></el-input>
      </el-form-item>
      <el-form-item prop="pass">
        <el-input v-model="ruleForm.pass" placeholder="输入新密码："></el-input>
      </el-form-item>
      <el-form-item prop="checkPass" class="marBot0">
        <el-input v-model="ruleForm.checkPass" placeholder="确认新密码："></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">确认修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { editPwd } from "@/api/getData";
export default {
  name: "ChangePassword",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldPass: '',
        pass: '',
        checkPass: '',
      },
      rules: {
        oldPass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            oldPwd: this.ruleForm.oldPass,
            newPwd: this.ruleForm.pass
          }
          editPwd(this.vUserId,data).then(res => {
            this.$message.success('修改成功')
            this.$store.commit("Logout");
            this.$router.replace('/login-pwd')
          })
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.changePassword {
  padding: 0 0.16rem;
  h2 {
    font-size: 0.18rem;
    margin: 0.4rem 0;
  }
  .el-button{
    margin-top: 0.3rem;
  }
}
</style>